// extracted by mini-css-extract-plugin
module.exports = {"text":"text-uuitU","switcher_wrapper":"switcher_wrapper-G7xSh","popup_wrapper":"popup_wrapper-Fc5Qo","add_btn":"add_btn-i6AaR"};